<template>
  <div>
  <Header activePage="About"/>
  <div id="about">
    <div id="image">
      <img src="../assets/about_image.jpg" />
      <p>
        Image description: A drawn, black and white image showing a crowd
        of people marching forward with black flags flying. In the front
        of the crowd is a woman with her fist raised.
      </p>
      <p>
        Image by Josh McPhee via justseeds.org
      </p>
    </div>
    <div id="text">
      <p>
        There is significant evidence to conclude that agencies within the
        United States government, particularly the Deparment of Homeland
        Security, are using their police power and that of other agencies to
        stamp out dissenting voices in immigrant communities. By targeting
        activists and organizers with detention, deportation, criminal prosecution,
        and surveillance, the government is sending a message that immigrant rights
        defenders should be fearful to exercise their rights to speak and associate
        freely.
      </p>
      <p>
        Immigrant rights defenders have experienced repression and retaliation
        through various means, all designed to spread fear among immigrant communities
        and those who support them. These include, though are not limited to:
      </p>
      <p>
        <b>Arresting and deporting immigrants who speak out.</b> By surveilling, arresting,
         and deporting immigrants who speak out against abuses — whether related to immigration
         or other forms of advocacy — the government sends a message that non-citizens’ rights
         to free speech, expression, and association are not worthy of protection.
      </p>
      <p>
        <b>Targeting leaders of immigrant rights organizations.</b> By detaining,
        deporting, prosecuting, and surveilling community leaders, government agencies
        interfere with the work of existing organizations and dissuade others from
        joining these organizations or creating their own groups to highlight abuses
        they are facing.
      </p>
      <p>
        <b>Surveilling and detaining those who offer legal, humanitarian, and spiritual
        support to migrants or who amplify their voices.</b> By stopping and interrogating
        journalists, faith leaders, and conscious observers at the border, the government
        intimidates those who work to defend immigrants against state repression.
      </p>
      <p><b>Monitoring and conducting large-scale actions against immigrant rights
        organizations and communities engaging in peaceful protest.</b> By surveilling
        large-scale protests against policies like family separation and conducting
        retaliatory raids in Sanctuary Cities, agencies stoke fear in communities and
        local governments of the consequences of standing up for immigrants.</p>
      <p>
        <b>Retaliating against detained immigrants who protest conditions of confinement.</b>
        By using brutal beatings, force-feeding, solitary confinement, and reliatory transfers
        to other facilities, the government not only violates the basic rights of
        detainees, but also dissuades others from attempting to speak out against
        abuse within detention centers.
      </p>
      <p>
        Despite this atmosphere of repression and retaliation, immigrant rights
        defenders continue to speak out, to organize, and to advocate for their
        communities. Their voices will not be silenced. <b>These are their stories.</b>
      </p>
      <p>
        <b>
        Immigrant Rights Voices is a joint project of the NYU Immigrant Rights Clinic and
        the New Sanctuary Coalition. To reach us, please contact us at
        </b>
        <a href="mailto:immigrantrightsvoices@gmail.com">immigrantrightsvoices@gmail.com.</a>
      </p>
      <br/>
      <br/>
      <em>
        "Immigration Reform Leaders Arrested in Washington DC" by Nevele Otseog is
        licensed with CC BY 2.0. To view a copy of this license, visit
        <a href="https://creativecommons.org/licenses/by/2.0/">
          https://creativecommons.org/licenses/by/2.0/
        </a>
      </em>
    </div>
   </div>
  </div>
</template>

<script>
import Header from './Header.vue';

export default {
  name: 'About',
  components: {
    Header,
  },
};
</script>

<style scoped>
#about {
  position: absolute;
  top: 86px;
  bottom: 72px;
  left: 0;
  right: 0;
  text-align: left;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-left: 30px;
  margin-right: 30px;
}
#text {
  grid-area: 1/ 2/ 2/ 4;
  margin-left: 30px;
  margin-top: 30px;
  line-height: 1.35;
  margin-bottom: 30px;
}
#text p:first-of-type {
  margin: 0px;
}
#image {
  grid-area: 1/ 1/ 2/ 2;
  margin-top: 30px;
}
#image p {
  font-size: 12px;
}
#image img {
  width: 100%;
  margin-bottom: 30px;
}
@media screen and (max-width: 1000px){
  #about { display: block; }
  #text { margin-left: 0px; }
}
a {
  color: black;
}
a:visited{
  color:black;
}
</style>
